module.exports = __webpack_public_path__ + "img/CameraZOOM-20210712092625052.d505b45f.jpg";